// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"e0590b5c","198":"8a72e49a","282":"c4da61dd","307":"73ca4506","352":"3104692d","404":"7e96fb7b","406":"54be7991","607":"43aefbd3","668":"df84009e","715":"808a736a","787":"430cec7d","818":"68ce9b83","837":"5018bf4d","953":"4b01bd21"}[chunkId] + ".chunk.js";
};